import { useEffect } from 'react';
import { useGameSocket } from './hooks/useGameSocket';
import { useGameStore, usePhase } from './store/gameStore';
import Lobby from './Lobby';
import Game from './Game';
import SeoFooter from './components/SeoFooter';
import { EtooLogo } from './components/EtooLogo';
import { resolveRoomFromUrl } from './router';

export default function App() {
  const socket = useGameSocket();
  const phase = usePhase();

  useEffect(() => {
    const onPopState = () => {
      const code = resolveRoomFromUrl();
      if (code) {
        socket.rejoin();
      } else {
        useGameStore.getState().reset();
      }
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [socket.rejoin]);

  return (
    <>
      {phase === 'lobby' ? <Lobby socket={socket} /> : <Game socket={socket} />}
      <EtooLogo />
      <SeoFooter />
    </>
  );
}
